<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  /* TailwindCSS imports */
  @import './tailwind.css';
  
  /* Custom fonts */
  @import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800");
  @import url("https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900");
  
  /* App visibility fix */
  #app {
    opacity: 1 !important;
    visibility: visible !important;
    display: block !important;
  }
  
  /* Custom component styles */
  @layer components {
    .button {
      @apply inline-block px-6 py-3 bg-primary text-white no-underline rounded transition-colors duration-300 hover:bg-secondary hover:text-white hover:no-underline;
    }
    
    .container {
      @apply max-w-6xl mx-auto px-4;
    }
    
    .section {
      @apply py-16;
    }
  }
  
  /* Remove padding since we want transparent header to overlay content */
  
  /* Ensure nav displays horizontally */
  @media (min-width: 1024px) {
    nav {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      gap: 2rem !important;
    }
  }
  
  /* Backdrop blur support */
  @supports (backdrop-filter: blur(8px)) {
    .backdrop-blur-md {
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
    }
    .backdrop-blur-sm {
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
    }
  }
</style>